/**
 * How an attendance record was registered.
 */
export enum AttendanceRecordSource {
  /** The professional registered it, on their own device, with the location of the device */
  Self = 'self',
  /** Someone else registered it on behalf of the professional. It has no location. */
  Manual = 'manual',
}
